import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CityService} from '@services/city.service';
import {AdService} from '@services/ad.service';
import {CommonService} from '@services/common.service';
import {Favorite} from '@models/favorite';
import {User} from '@models/user';
import {EMPTY_USER} from '@models/empty';
import {AuthenticationService} from '@services/authentification.service';

@Component({
    selector: 'app-achat',
    templateUrl: './achat.component.html',
    styleUrls: ['./achat.component.scss']
})
export class AchatComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;
    @Output() favoriteChange = new EventEmitter();

    user: User = Object.assign({}, EMPTY_USER);

    constructor(public cityService: CityService,
                public adService: AdService,
                public authenticationService: AuthenticationService,
                public commonService: CommonService) {
    }

    edit(event, fields = '') {
        this.favorite = this.adService.cleanInput(this.favorite);

        if (fields === 'price' || fields === 'estate_sale') {
            // Set to null to calculate it
            if (this.favorite.apport === this.favorite.notary_price) {
                this.favorite.apport = null;
            }
            this.favorite.notary_price = null;
        }

        if (this.authenticationService.currentUser.pro_plan == 'oikos') {
            if (fields === 'price') {
                this.favorite.other_fees = null;
            } else if (fields === 'works_help' || fields === 'works_square_price' || fields === 'works_total') {
                this.favorite.other_fees_work = null;
            }
        }

        if (this.favorite.lots.length === 1) {
            if (fields === 'works_total') {
                this.favorite.works_help = -1;
                this.favorite.works_square_price = null;
            } else if (fields === 'works_square_price') {
                this.favorite.works_total = null;
            }
        }

        this.favorite = this.adService.updateValues(this.favorite);
        this.favoriteChange.emit();
    }

    worksToogle(e) {
        this.favorite.works_deduc = e.checked;
        this.favoriteChange.emit();
    }

    ngOnInit() {
        this.favorite = this.adService.updateValues(this.favorite);
        this.user = this.authenticationService.currentUser;
    }
}
